export default () : any | null => {
  const userData = localStorage.getItem('userData') || sessionStorage.getItem('userData')

  if (!userData) {
    return null
  }

  return JSON.parse(userData)
}
